/* Progressive enhancements for the existing Blog article markup. */
(function () {
  'use strict';

  function init() {
    var configElement = document.getElementById('ds-journal-article-script');
    var config = configElement && configElement.dataset;
    // Missing configuration leaves the complete server-rendered guide usable.
    if (!config || !['journalUrl', 'returnLabel', 'contentsLabel', 'progressLabel', 'tableLabel', 'tableFallback'].every(function (key) { return config[key]; })) return;
    var root = document.querySelector('.ds-edu');
    var reading = root && root.querySelector('.ds-edu-reading');
    var article = reading && reading.querySelector('article');
    if (!root || !article || root.hasAttribute('data-journal-article-ready')) return;
    root.setAttribute('data-journal-article-ready', '');

    var narrow = window.matchMedia('(max-width: 760px)');
    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var breadcrumb = root.querySelector('.ds-edu-crumb');
    if (breadcrumb && !breadcrumb.querySelector('.ds-journal-return')) {
      var returnLink = document.createElement('a');
      returnLink.className = 'ds-journal-return';
      returnLink.href = config.journalUrl;
      var returnArrow = document.createElement('span');
      returnArrow.setAttribute('aria-hidden', 'true');
      returnArrow.textContent = '\u2190';
      returnLink.append(returnArrow, document.createTextNode(config.returnLabel));
      breadcrumb.prepend(returnLink);
    }

    var contents = reading.querySelector('aside nav');
    var links = contents ? Array.from(contents.querySelectorAll('a[href^="#"]')) : [];
    var chapters = links.map(function (link) {
      var id = link.getAttribute('href').slice(1);
      var target = document.getElementById(id);
      return target && article.contains(target) ? { link: link, target: target } : null;
    }).filter(Boolean);
    var toggle;
    var expanded = false;

    function setExpanded(value) {
      expanded = value;
      if (!toggle) return;
      toggle.setAttribute('aria-expanded', String(value));
      toggle.lastElementChild.textContent = value ? '\u2212' : '+';
      contents.hidden = narrow.matches && !value;
    }

    function syncContents() {
      if (!toggle) return;
      var focusedInside = contents.contains(document.activeElement);
      if (narrow.matches) {
        // Do not hide the current keyboard focus when the viewport changes.
        setExpanded(focusedInside || expanded);
      } else {
        contents.hidden = false;
        toggle.setAttribute('aria-expanded', 'true');
      }
    }

    if (contents && chapters.length) {
      if (!contents.id) contents.id = 'ds-journal-contents';
      toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'ds-journal-contents-toggle';
      toggle.setAttribute('aria-controls', contents.id);
      var title = document.createElement('span');
      title.textContent = config.contentsLabel;
      var symbol = document.createElement('span');
      symbol.setAttribute('aria-hidden', 'true');
      symbol.textContent = '+';
      toggle.append(title, symbol);
      contents.before(toggle);
      toggle.addEventListener('click', function () { setExpanded(!expanded); });
      syncContents();

      contents.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && narrow.matches && expanded) {
          setExpanded(false);
          toggle.focus();
          event.preventDefault();
        }
      });

      chapters.forEach(function (chapter) {
        chapter.link.addEventListener('click', function (event) {
          if (!narrow.matches || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          setExpanded(false);
          if (!chapter.target.hasAttribute('tabindex')) chapter.target.setAttribute('tabindex', '-1');
          chapter.target.focus({ preventScroll: true });
          var hash = chapter.link.getAttribute('href');
          if (location.hash !== hash) history.pushState(null, '', hash);
          chapter.target.scrollIntoView({ behavior: reducedMotion.matches ? 'auto' : 'smooth', block: 'start' });
          queueUpdate();
        });
      });
    }

    // Keyboard users can scroll wide editorial tables without moving the page.
    Array.from(article.querySelectorAll('.ds-edu-table')).forEach(function (table, index) {
      table.setAttribute('tabindex', '0');
      table.setAttribute('role', 'region');
      var heading = table.closest('.ds-edu-chapter');
      heading = heading && heading.querySelector('h2');
      table.setAttribute('aria-label', config.tableLabel.replace('__NUMBER__', String(index + 1)).replace('__TITLE__', heading ? heading.textContent.trim() : config.tableFallback));
    });

    var progress = document.createElement('div');
    progress.className = 'ds-journal-progress';
    progress.setAttribute('role', 'progressbar');
    progress.setAttribute('aria-label', config.progressLabel);
    progress.setAttribute('aria-valuemin', '0');
    progress.setAttribute('aria-valuemax', '100');
    progress.setAttribute('aria-valuenow', '0');
    var fill = document.createElement('span');
    progress.append(fill);
    root.prepend(progress);

    var header = document.querySelector('[data-ds-shared-header] .shop-header, .ds-header-root .shop-header');
    var queued = false;
    var previousEdge = -1;
    var previousValue = -1;
    var activeLink = null;

    function update() {
      queued = false;
      var headerBox = header && header.getBoundingClientRect();
      var edge = headerBox && headerBox.width && headerBox.height ? Math.max(0, Math.min(headerBox.bottom, window.innerHeight * 0.6)) : 0;
      edge = Math.round(edge);
      if (edge !== previousEdge) {
        root.style.setProperty('--ds-journal-header-edge', edge + 'px');
        previousEdge = edge;
      }
      var box = article.getBoundingClientRect();
      var availableHeight = Math.max(1, window.innerHeight - edge);
      var range = Math.max(1, box.height - availableHeight);
      var fraction = Math.max(0, Math.min(1, (edge - box.top) / range));
      var value = Math.round(fraction * 100);
      if (value !== previousValue) {
        fill.style.transform = 'scaleX(' + (value / 100) + ')';
        progress.setAttribute('aria-valuenow', String(value));
        previousValue = value;
      }
      var nextLink = null;
      if (box.bottom > edge && box.top < window.innerHeight) {
        for (var i = 0; i < chapters.length; i += 1) {
          if (chapters[i].target.getBoundingClientRect().top <= edge + 100) nextLink = chapters[i].link;
        }
        if (!nextLink && chapters.length) nextLink = chapters[0].link;
      }
      if (activeLink !== nextLink) {
        if (activeLink) activeLink.removeAttribute('aria-current');
        if (nextLink) nextLink.setAttribute('aria-current', 'location');
        activeLink = nextLink;
      }
    }

    function queueUpdate() {
      if (queued) return;
      queued = true;
      window.requestAnimationFrame(update);
    }

    window.addEventListener('scroll', queueUpdate, { passive: true });
    window.addEventListener('resize', queueUpdate, { passive: true });
    window.addEventListener('hashchange', queueUpdate);
    window.addEventListener('load', queueUpdate, { once: true });
    if (narrow.addEventListener) narrow.addEventListener('change', syncContents);
    else narrow.addListener(syncContents);
    if ('ResizeObserver' in window) {
      var observer = new ResizeObserver(queueUpdate);
      observer.observe(article);
      if (header) observer.observe(header);
    }
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(queueUpdate);
    queueUpdate();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
  document.addEventListener('shopify:section:load', init);
}());
